import { emitTimingToastToggle } from '@landingi/landingi-ui-kit'

export const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text)
  } catch {
    emitTimingToastToggle('Clipboard not supported', 'alert')
  }
}
